import { render, staticRenderFns } from "./SubGrupoProdutoModal.vue?vue&type=template&id=16fa0d96&scoped=true"
import script from "./SubGrupoProdutoModal.vue?vue&type=script&lang=js"
export * from "./SubGrupoProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./SubGrupoProdutoModal.vue?vue&type=style&index=0&id=16fa0d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa0d96",
  null
  
)

export default component.exports